// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/FeatureTextOnly.model';
import { Themes } from 'lib/themes';
import { usePreambleFields } from 'components/helpers/Molecules/Preamble/Preamble.sitecore';
import { PreambleOrientation } from 'components/helpers/Molecules/Preamble/Preamble';
import { FeatureTextOnly } from './FeatureTextOnly';

type FeatureTextOnlyProps = Content.FeatureTextOnly.FeatureTextOnly_Component & {
  params: {
    preambleOrientation?: PreambleOrientation;
    theme?: Themes;
  };
};

const FeatureTextOnlyWrapper = (props: FeatureTextOnlyProps) => {
  /*
   * Rendering
   */

  const preambleFields = usePreambleFields({
    fields: props.fields,
  });

  if (!props.fields) {
    return <></>;
  }
  return (
    <FeatureTextOnly
      theme={props.params?.theme}
      preambleOrientation={props.params?.preambleOrientation}
      {...preambleFields}
    />
  );
};

export const Default = FeatureTextOnlyWrapper;
